import { PropertySelector } from '@components/ui/property-selector';
import { useAppSelector } from '../../store';

const DashboardHeader = ({
  v2,
  disableAllProperties,
}: {
  v2?: boolean;
  disableAllProperties?: boolean;
}) => {
  const selectedProperty = useAppSelector(
    (state) => state.properties.selectedProperty,
  );

  return (
    <>
      <PropertySelector
        initialValue={selectedProperty}
        v2={v2}
        disableAllProperties={disableAllProperties}
      />
    </>
  );
};

export default DashboardHeader;
